/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jul 25 2024
 **/
import styled from "@emotion/styled";

import { Column } from "@/frameworks/designStuff/components";

export const Container = styled(Column)`
	width: 100%;
	height: 100%;
	border-radius: 12px;
	padding: 28px 32px 0px 32px;
`;

export const IconContainer = styled(Column)`
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.deco6_10_100};
	margin-right: 8px;
`;

export const MessageContainer = styled(Column)`
	width: 100%;
	height: auto;
	border-radius: 8px;
	padding: 16px 20px;
	word-break: break-all;
	background-color: ${({ theme }) => theme.colors.neutral_10_80};
`;
